export default __webpack_public_path__ + "static/media/aras-cargo-logo.32abc6c1.png";